import { createFileRoute, redirect } from "@tanstack/react-router";

import { hasPermission } from "@/modules/auth/lib/permissions";
import { RepairDetailPage } from "@/modules/repairs/pages/RepairDetail.page";

export const Route = createFileRoute("/__authed/m/repairs/$id")({
	beforeLoad({ context }) {
		const user = "user" in context ? context.user : undefined;

		if (!hasPermission(user, "see_repair")) {
			throw redirect({ to: "/m/dashboard" });
		}
	},
	component: RouteComponent,
});

function RouteComponent() {
	const { id } = Route.useParams();

	return <RepairDetailPage repairId={id} />;
}
